module.exports = __webpack_public_path__ + "static/media/13.215ef100.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/boulders/13.jpg
// module id = 472
// module chunks = 0